import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Webhooks" hint="Doesn't exist in rr-backend yet — placeholder for when webhooks ship." /> }
